import { render, staticRenderFns } from "./MarketplaceCommunity.vue?vue&type=template&id=5e81220f&scoped=true"
import script from "./MarketplaceCommunity.vue?vue&type=script&lang=js"
export * from "./MarketplaceCommunity.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceCommunity.vue?vue&type=style&index=0&id=5e81220f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e81220f",
  null
  
)

export default component.exports